export default function Iconos_derecha(){
    return(
        <div className="d-none d-md-block col-md-3 text-end p-3">
            <a href="https://twitter.com/TEPJF_informa" target="_blank" rel="noreferrer" className="mx-1"><i className="fab fa-twitter-square fa-lg"></i></a>
            <a href="https://www.facebook.com/TEPJF" target="_blank" rel="noreferrer" className="mx-1"><i className="fab fa-facebook-square fa-lg"></i></a>
            <a href="https://www.youtube.com/user/TEPJF" target="_blank" rel="noreferrer" className="mx-1"><i className="fab fa-youtube-square fa-lg"></i></a>
        </div>
    )
}